module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_heading-ashinagasan-sp-f122c61818b30f0adec7edcf2e839119.png";